export const BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM = 'biasharaFlexi/uploadDocumentsForm/';

export const BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALUE = BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM + 'setValue/';
export const BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALID = BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM + 'setValid/';

export const FORM_VALID_BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM = 'biasharaFlexi/uploadDocumentsForm/transition/formValid';
export const FORM_INVALID_BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM =
    'biasharaFlexi/uploadDocumentsForm/transition/formInValid';

export const transitionBiasharaFlexiUploadDocuments = {
    formValid: () => ({
        type: FORM_VALID_BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM,
    }),
};

// API Calls actions
export const API_INITIAL_TRANSITION_UPLOAD_DOCUMENTS_FORM = `${BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALUE}/apiTransition/initial`;
export const API_PENDING_TRANSITION_UPLOAD_DOCUMENTS_FORM = `${BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_UPLOAD_DOCUMENTS_FORM = `${BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_UPLOAD_DOCUMENTS_FORM = `${BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALUE}/apiTransition/failure`;

export const apiTransitionBiasharaFlexiUploadDocumentsForm = {
    initial: () => ({
        type: API_INITIAL_TRANSITION_UPLOAD_DOCUMENTS_FORM,
    }),
    pending: () => ({
        type: API_PENDING_TRANSITION_UPLOAD_DOCUMENTS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_UPLOAD_DOCUMENTS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_UPLOAD_DOCUMENTS_FORM,
    }),
};

export const INCORPORATION_COPY_SET_VALUE = BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALUE + 'incorporationCertificate';
export const INCORPORATION_COPY_SET_VALID = BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALID + 'incorporationCertificate';

export const KRA_PIN_CERTIFICATE_COPY_SET_VALUE = BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALUE + 'kraCertificate';
export const KRA_PIN_CERTIFICATE_COPY_SET_VALID = BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM_SET_VALID + 'kraCertificate';

export const BIASHARA_FLEXI_SUBMIT_UPLOAD_DOCUMENTS = BIASHARA_FLEXI_UPLOAD_DOCUMENTS_FORM + 'submitUploadDocuments';

export const setIncorporationCertificateCopyValue = (value) => ({
    type: INCORPORATION_COPY_SET_VALUE,
    value,
});

export const setIncorporationCertificateCopyValid = (error) => ({
    type: INCORPORATION_COPY_SET_VALID,
    error,
});

export const setKraPinCertificateCopyValue = (value) => ({
    type: KRA_PIN_CERTIFICATE_COPY_SET_VALUE,
    value,
});

export const setKraPinCertificateCopyValid = (error) => ({
    type: KRA_PIN_CERTIFICATE_COPY_SET_VALID,
    error,
});

export const submitUploadDocuments = () => ({
    type: BIASHARA_FLEXI_SUBMIT_UPLOAD_DOCUMENTS,
});
